// https://css-tricks.com/using-css-transitions-auto-dimensions/
// https://stackoverflow.com/questions/48524525/workaround-for-arguments-callee-on-javascript-slide-down

function collapseSection(element) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;

  // temporarily disable all css transitions
  var elementTransition = element.style.transition;
  element.style.transition = '';

  // on the next frame (as soon as the previous style change has taken effect),
  // explicitly set the element's height to its current pixel height, so we
  // aren't transitioning out of 'auto'
  requestAnimationFrame(function () {
    element.style.height = sectionHeight + 'px';
    element.style.transition = elementTransition;

    // on the next frame (as soon as the previous style change has taken effect),
    // have the element transition to height: 0
    requestAnimationFrame(function () {
      element.style.height = 0 + 'px';
    });
  });

  // mark the section as "currently collapsed"
  element.setAttribute('data-collapsed', 'true');
}

function expandSection(element) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;

  // have the element transition to the height of its inner content
  element.style.height = sectionHeight + 'px';

  // when the next css transition finishes (which should be the one we just triggered)
  element.addEventListener('transitionend', function () {
    // remove this event listener so it only gets triggered once
    //element.removeEventListener('transitionend', arguments.callee);

    // remove "height" from the element's inline styles, so it can return to its initial value
    element.style.height = null;
  }, { once: true });

  // mark the section as "currently not collapsed"
  element.setAttribute('data-collapsed', 'false');
}

jQuery(function() {

  $('.faq__question:not(".open")').each(function(){
    var $section = $(this).find('.faq__question__text');
    $section[0].style.height = 0 + 'px';
  });

  $('.faq__question__title').on('click', function(){
    var $parent = $(this).closest('.faq__question');
    var $section = $parent.find('.faq__question__text');
    $parent.toggleClass('open');

    if ($parent.hasClass('open')) {
      expandSection($section[0])
    } else {
      collapseSection($section[0])
    }
  });

});
